import React, {Component} from "react";
import {connect} from "react-redux";
import Moment from "moment";
import {Components} from "@webtech/webtech-ui-react/build/webtech-ui";
import {formatDateText} from "../../../../../../../utils/utils";

import {ActionCreator} from "../../../../../../../actions/actions";
import {hallsStoreSelectors} from "../../../../../store/store";
import {HallsActionCreators} from "../../../../../actions/actionCreators";

import {LicenseServerData, ServerLicense} from "../../../../../reducers/licenses.reducer";

import "./LicenseApplied.component.scss";
import {Dialog} from "../../../../../../../utils/Dialog/Dialog.component";
import {checkPermission} from "../../../../../../../utils/Authorization/authorization";

export interface LicenseAppliedProps {
    serverLicenseLoading: boolean;
    serverLicense: ServerLicense;
    getServerLicense: ActionCreator;
    cancelLicenseProcess: ActionCreator;
    getLicenseDownload: ActionCreator;
    renewLicense: ActionCreator;
    updateRemotelyLicense: ActionCreator;
    invalidateLicense: ActionCreator;
    getServer: ActionCreator;
    serverId: number;
    serverName: string;
    allow: boolean;
    serverIsOnline: boolean;
    lastOnline?: any;
    systemServerLicense: LicenseServerData | null
}

export interface LicenseAppliedState {
    confirmCancel: boolean;
    lastRemoteUpdate?: any;
}

class LicenseApplied extends Component<
    LicenseAppliedProps,
    LicenseAppliedState
> {
    constructor(props) {
        super(props);
        this.state = {
            confirmCancel: false,
            lastRemoteUpdate: null
        };
    }

    componentDidMount() {
        if (
            !this.props.serverLicense ||
            this.props.serverLicense.server_id != this.props.serverId
        ) {
            this.props.getServerLicense({
                serverId: this.props.serverId
            });
        }
    }

    componentWillReceiveProps(nextProps: Readonly<LicenseAppliedProps>) {
        if (nextProps.serverLicense && nextProps.serverLicense['server_license_state'] &&
            nextProps.serverLicense['server_license_state']['last_remote_update_attempt'] !== this.state.lastRemoteUpdate) {
            this.setState({
                lastRemoteUpdate: nextProps.serverLicense['server_license_state']['last_remote_update_attempt'] ?
                    nextProps.serverLicense['server_license_state']['last_remote_update_attempt'] :
                    null
            })
        }
    }

    render() {
        if (this.props.serverLicenseLoading) {
            return (
                <div className="loading">
                    <Components.LoadingRipple height={100} width={100}/>
                </div>
            );
        }

        if (!this.props.serverLicense) {
            return (
                <div className="loading">
                    <p>
                        Could not load license information. Please try again
                        later.
                    </p>
                </div>
            );
        }

        let todayDate = Moment();

        let expirationDateWaveLicense = Moment(this.props.serverLicense.expiration);
        let daysLeftWaveLicense = expirationDateWaveLicense.diff(todayDate, "days");

        let expirationDateServerLicense = this.props.systemServerLicense &&
        this.props.systemServerLicense.license &&
        this.props.systemServerLicense.license.end_license
            ? Moment(this.props.systemServerLicense.license.end_license)
            : null;
        let daysLeftServerLicense = expirationDateServerLicense ? expirationDateServerLicense.diff(todayDate, "days") : null;

        let lastRemoteUpdate = this.state.lastRemoteUpdate ?
            todayDate.diff(Moment(this.state.lastRemoteUpdate), "minute") : 11
        /**
         * - license = null
         * - seq. number lic do wave != seq. number lic server && ((last update != null && (last update - current time) >= 10 m) or last update = null)
         * - seq. number lic do wave == seq. number lic server && (server lic expired/invalid && wave lic not expired)
         */
        let enabledRemotelyLicenseButton = !(this.props.systemServerLicense && this.props.systemServerLicense.license) ||
            (this.props.systemServerLicense.license.seq_number !== this.props.serverLicense.sequence_number && (lastRemoteUpdate >= 10)) ||
            (this.props.systemServerLicense.license.seq_number == this.props.serverLicense.sequence_number && (this.props.systemServerLicense.license.expired && !this.props.serverLicense.expired))

        /**
         * - license != null && server lic not expired
         */
        let enabledInvalidateLicenseButton = this.props.systemServerLicense && this.props.systemServerLicense.license && !this.props.systemServerLicense.license.expired

        return (
            <div className="col-12">
                <div className="license-applied-container">
                    {this.props.serverIsOnline &&
                        <div
                            className="tooltip-icon icon-refresh"
                            onClick={() => {
                                this.props.getServerLicense({
                                    serverId: this.props.serverId
                                });
                                this.props.getServer({
                                    serverId: this.props.serverId
                                });
                            }
                            }
                        >
                            <span className="tooltip-text">Refresh</span>
                            <i className="icon-history-light"/>
                        </div>
                    }

                    <div className="row">
                        <div className="col-5">
                            <span className="license-applied-title">
                                License Applied
                            </span>
                            {checkPermission("download_license") &&
                                <div
                                    className="red-btn download-btn"
                                    onClick={() => {
                                        this.props.getLicenseDownload({
                                            serverId: this.props.serverId,
                                            serverName: this.props.serverName
                                        });
                                    }}
                                >
                                    <i className="icon-file-archive-light"/>
                                    Download License
                                </div>
                            }

                            {checkPermission("view_license") &&
                                <div>
                                    <span className={"license-applied-section-title"}>
                                        Wave Status
                                    </span>
                                    <div className="not-applied-timer">
                                        <div className="not-applied-timer-section">
                                            <div className="not-applied-timer-section-title">
                                                {this.props.serverLicense.expired ==
                                                true
                                                    ? "DAYS AGO"
                                                    : "DAYS LEFT"}
                                            </div>

                                            <div className="not-applied-timer-section-value">
                                                {Math.abs(daysLeftWaveLicense)}
                                            </div>
                                        </div>

                                        <div className="not-applied-timer-section">
                                            <div className="not-applied-timer-section-title">
                                                {this.props.serverLicense.expired ==
                                                true
                                                    ? "EXPIRED ON"
                                                    : "EXPIRES ON"}
                                            </div>

                                            <div className="not-applied-timer-section-value">
                                                {`${
                                                    this.props.serverLicense.expiration
                                                        ? Moment(
                                                            this.props.serverLicense
                                                                .expiration
                                                        ).format("YYYY-MM-DD")
                                                        : "--"
                                                }`}
                                            </div>
                                        </div>
                                        <div className="license-applied-icon-container">
                                            {!this.props.serverLicense.expired && (
                                                <i className="icon-check-circle-light valid"/>
                                            )}
                                            {this.props.serverLicense.expired && (
                                                <i className="icon-times-circle-light expired"/>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            }
                            {checkPermission("view_license") && this.props.lastOnline &&
                                <div>
                                    <span className={"license-applied-section-title"}>
                                        Live Status - Last updated: {this.props.lastOnline
                                        ? formatDateText(this.props.lastOnline)
                                        : "--"}
                                    </span>
                                    <div className="not-applied-timer">
                                        <div className="not-applied-timer-section">
                                            <div className="not-applied-timer-section-title">
                                                {this.props.systemServerLicense && this.props.systemServerLicense.license && !this.props.systemServerLicense.license.expired
                                                    ? "DAYS LEFT"
                                                    : "DAYS AGO"}
                                            </div>

                                            <div className="not-applied-timer-section-value">
                                                {daysLeftServerLicense ? Math.abs(daysLeftServerLicense) : "--"}
                                            </div>
                                        </div>
                                        <div className="not-applied-timer-section">
                                            <div className="not-applied-timer-section-title">
                                                {this.props.systemServerLicense && this.props.systemServerLicense.license && !this.props.systemServerLicense.license.expired
                                                    ? "EXPIRES ON"
                                                    : "EXPIRED ON"}
                                            </div>

                                            <div className="not-applied-timer-section-value">
                                                {`${this.props.systemServerLicense &&
                                                this.props.systemServerLicense.license &&
                                                this.props.systemServerLicense.license.end_license
                                                    ? Moment(
                                                        this.props.systemServerLicense.license
                                                            .end_license
                                                    ).format("YYYY-MM-DD")
                                                    : "--"
                                                }`}
                                            </div>
                                        </div>
                                        <div className="license-applied-icon-container">
                                            {this.props.systemServerLicense && this.props.systemServerLicense.license && !this.props.systemServerLicense.license.expired ? (
                                                    <i className="icon-check-circle-light valid"/>
                                                ) :
                                                (
                                                    <i className="icon-times-circle-light expired"/>
                                                )}
                                        </div>
                                    </div>
                                </div>
                            }

                        </div>
                        <div className="col-1">&nbsp;</div>
                        <div className="col-6">
                            {this.props.allow &&
                                checkPermission("manage_licensing") && (
                                    <div className="license-applied-buttons">
                                        {this.props.serverIsOnline &&
                                            <div>
                                                <p>
                                                    With this action it is possible to
                                                    apply the license remotely.
                                                </p>
                                                <button
                                                    className="btn"
                                                    disabled={!enabledRemotelyLicenseButton}
                                                    onClick={() => {
                                                        this.props.updateRemotelyLicense({
                                                            serverId:
                                                            this.props.serverId
                                                        });
                                                    }}
                                                >
                                                    Update Remotely
                                                </button>
                                                <p>
                                                    With this action it is possible to invalidate the license remotely.
                                                </p>
                                                <button
                                                    className="btn"
                                                    disabled={!enabledInvalidateLicenseButton}
                                                    onClick={() => {
                                                        this.props.invalidateLicense({
                                                            serverId:
                                                            this.props.serverId
                                                        });
                                                    }}
                                                >
                                                    Invalidate License
                                                </button>
                                            </div>
                                        }
                                        <p>
                                            With this action it's possible to
                                            renew the license without redo the
                                            inital steps.
                                        </p>
                                        <button
                                            className="btn"
                                            onClick={() => {
                                                this.props.renewLicense({
                                                    serverId:
                                                    this.props.serverId
                                                });
                                            }}
                                        >
                                            Renew License
                                        </button>
                                    </div>
                                )}
                            {this.props.allow && (checkPermission("manage_licensing") || checkPermission("cancel_license")) &&
                                <div className="license-applied-buttons">
                                    <p>
                                        This action restarts all licensing
                                        process and will require a seed from
                                        the server.
                                    </p>
                                    <button
                                        className="btn"
                                        onClick={() => {
                                            this.setState({
                                                confirmCancel: true
                                            });
                                        }}
                                    >
                                        Cancel License
                                    </button>
                                </div>
                            }
                        </div>
                    </div>
                </div>

                <Dialog
                    open={this.state.confirmCancel}
                    onConfirm={() => {
                        this.props.cancelLicenseProcess({
                            serverId: this.props.serverId
                        });
                    }}
                    onClose={() => {
                        this.setState({
                            confirmCancel: false
                        });
                    }}
                >
                    <p>
                        <b>ATTENTION</b>
                    </p>
                    <span>
                        Canceling this license will
                        <b>{this.props.serverIsOnline ? " terminate de license remotely and " : " "} require a new seed upload</b>. Proceed with caution
                        and verify if a seed file exists or can be downloaded
                        from the server.
                    </span>
                </Dialog>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    serverLicense: hallsStoreSelectors.serverLicense(state),
    serverLicenseLoading: hallsStoreSelectors.serverLicenseLoading(state)
});

const mapDispatchToProps = {
    getServerLicense: HallsActionCreators.getServerLicense,
    getServer: HallsActionCreators.getServer,
    cancelLicenseProcess: HallsActionCreators.cancelLicenseProcess,
    renewLicense: HallsActionCreators.renewLicense,
    getLicenseDownload: HallsActionCreators.getLicenseDownload,
    invalidateLicense: HallsActionCreators.invalidateLicense,
    updateRemotelyLicense: HallsActionCreators.updateRemotelyLicense
};

export default connect(mapStateToProps, mapDispatchToProps)(LicenseApplied);
